import { ICalendarAuthAccount } from 'APP/model/calendar/calendar.types';
import { calendarModel } from 'APP/model/model';

export const checkCalendarAuthorization = async (): Promise<ICalendarAuthAccount[]> => {
  try {
    const response = await calendarModel.checkCalendarAuthorization();

    return response;
  } catch {
    return [];
  }
};
